<svg class="circle-progress" width="190" height="190" viewBox="0 0 190 190">
  <circle class="circle-progress-meter" cx="95" cy="95" r="88" stroke-width="7"></circle>
  <circle #progressValue class="circle-progress-value" cx="95" cy="95" r="88" stroke-width="10" stroke-linecap="round"></circle>
</svg>

